import { useQuery } from "@tanstack/react-query";
import {
  adminAuditApi,
  AdminAuditPage,
  AdminAuditSource,
} from "@/services/adminAuditApi";

/** Entries per page in the history dialog. The server caps a page at 200. */
export const ADMIN_AUDIT_PAGE_SIZE = 20;

/**
 * One page of an admin entity's change history.
 *
 * Pass `entityId: undefined` while the dialog is closed so no request is made until
 * it opens. Previous results are kept while the next page loads, so paging does not
 * blank the table between fetches.
 */
export function useAdminAuditHistory(
  source: AdminAuditSource,
  entityId: string | undefined,
  page: number
) {
  return useQuery<AdminAuditPage>({
    queryKey: ["admin-audit", source, entityId, page],
    queryFn: () =>
      adminAuditApi.getHistory(source, entityId!, {
        limit: ADMIN_AUDIT_PAGE_SIZE,
        offset: (page - 1) * ADMIN_AUDIT_PAGE_SIZE,
      }),
    enabled: !!entityId,
    placeholderData: (prev) => prev,
  });
}
